import { render } from "./categoryModel.vue?vue&type=template&id=1f613bd2&scoped=true"
import script from "./categoryModel.vue?vue&type=script&lang=js"
export * from "./categoryModel.vue?vue&type=script&lang=js"

import "./categoryModel.vue?vue&type=style&index=0&id=1f613bd2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f613bd2"]])

export default __exports__